import React from 'react';
import { Box } from '@mui/material';
import { useProjects } from '../../../providers/ProjectProvider';
import PageLoader from '../../../common/PageLoader';
import ProjectCard from './ProjectCard';
import style from './GridView.module.scss';

const GridView = ({ handleNavigate }) => {
  const { projects, loading } = useProjects();
  if (loading) {
    return <PageLoader />;
  }

  return (
    <Box className={style.outerGrid}>
      {
        Object.keys(projects).map((key) => {
          const companyProjects = projects[key];
          return (
            <div className={style.companyGroup} key={key}>
              <Box className={style.companyHeader}>
                <span className={style.companyName}>{key}</span>
                <span className={style.projectCount}>
                  {companyProjects.length}
                  {' '}
                  {
companyProjects.length === 1
  ? 'PROJECT'
  : 'PROJECTS'
}
                </span>
              </Box>
              <Box className={style.grid}>
                {
                  companyProjects.map((project) => (
                    <ProjectCard
                      key={project.builderId}
                      project={project}
                      handleNavigate={
                        () => handleNavigate(project.builderId)
                      }
                    />
                  ))
                }
              </Box>
            </div>
          );
        })
      }
    </Box>
  );
};

export default GridView;
